module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pendingMessage":"Daten werden gespeichert, bitte warten...","editButtonLabel":"Bearbeiten","cancelButtonLabel":"Abbrechen","saveButtonLabel":"Speichern"}}')
  delete Component.options._Ctor
}
